import React from "react";
import ModuleBreadcrumbs from "components/ModuleBreadcrumbs";
import { Title } from "@skyportal/ui-kit";

import styles from "./styles.module.css";

export interface PageHeaderProps {
  title: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  return (
    <header className={styles.root}>
      <ModuleBreadcrumbs />
      <Title level={2}>{title}</Title>
    </header>
  );
};

export default PageHeader;
